var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col items-center justify-center"})
}
var staticRenderFns = []

export { render, staticRenderFns }